import { render, staticRenderFns } from "./CampanhasOficiaisRedirect.vue?vue&type=template&id=01ab2f1e&scoped=true"
import script from "./CampanhasOficiaisRedirect.vue?vue&type=script&lang=js"
export * from "./CampanhasOficiaisRedirect.vue?vue&type=script&lang=js"
import style0 from "./CampanhasOficiaisRedirect.vue?vue&type=style&index=0&id=01ab2f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab2f1e",
  null
  
)

export default component.exports